import { cn } from "../../helpers"
import { body, paragraph } from "../typography"

const container = cn("flex gap-3 py-3 border-b border-neutral-200 justify-between items-center")
const textContainer = cn("flex flex-col gap-1")
const title = cn(body({ size: "sm" }))
const subtitle = cn(paragraph({ size: "sm", className: "text-neutral-700" }))

export { container, textContainer, title, subtitle }
